// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".summary-table h4[data-v-701cd1da]{margin-left:.75rem}.summary-table tr td[data-v-701cd1da]:first-child{width:1%;white-space:nowrap}.summary-table tr td[data-v-701cd1da]{font-size:1.125rem;font-weight:700}", ""]);
// Exports
module.exports = exports;
